import Api from '@api/xiao_xiong/appealResult'
import { action, observable, runInAction } from 'mobx'

class Store {
  id // 申诉id
  kind // 是否为问答
  setId = (id, kind) => {
    this.id = id
    this.kind = kind
  }

  /**
   * 申诉结果
   *
   */
  @observable appeal_status = '' //是否成功
  @observable created_at = '' //申诉时间
  @observable content = '' //申诉内容
  @observable reason = '' //申诉原因
  @observable photos = [] //申述图片
  @observable community_comment = {} //回复节点
  @observable order_comment = {} //评价节点

  @observable qa_answer = {} // 回答节点
  @observable qa_question = {} //问题节点

  @action
  getAppealInfo = async () => {
    if (this.kind == 'question') {
      const { data = {}, success } = await Api.getResult_questionApi({
        id: this.id
      }) //id 要改一下 测试的id为1
      if (success) {
        runInAction(() => {
          this.appeal_status = data.status //这里为status 状态对应要跟原来的统一一下
          this.created_at = data.created_at
          this.content = data.content
          this.reason = data.reason
          this.photos = data.photos || []
          this.qa_answer = data.qa_answer || {} // 回答节点
          this.qa_question = data.qa_question || {} // 提问节点
        })
      }
    } else {
      const { data = {}, success } = await Api.getResultApi({ id: this.id })
      if (success) {
        runInAction(() => {
          this.appeal_status = data.appeal_status
          this.created_at = data.created_at
          this.content = data.content
          this.reason = data.reason
          this.photos = data.photos || []
          this.community_comment = data.community_comment || {}
          this.order_comment = data.order_comment || {}
        })
      }
    }
  }
}
export default new Store()
